// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared/for-apps";
import { equal } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { untracked } from "@angular/core";
@jsonClass('Orders.CustomerRequestItem')
class Orders__CustomerRequestItem {
    @jsonProperty(() => Orders__CustomerRequestItem.Id)
    id: Orders__CustomerRequestItem.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: unwrapReadonly(Object.freeze(["id", "name", "quantities", "processingMethod", "processingMethod$id", "relatedAttachmentIds", "dimensions", "margin", "offeredPrice", "deliveryTimeWeeks", "request", "requestId", "materials", "customerOfferItem", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: unwrapReadonly(Object.freeze(["id", "name", "quantities", "processingMethod", "processingMethod$id", "relatedAttachmentIds", "dimensions", "margin", "offeredPrice", "deliveryTimeWeeks", "request", "requestId", "materials", "customerOfferItem", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: unwrapReadonly(Object.freeze(["id", "name", "quantities", "processingMethod", "relatedAttachmentIds", "dimensions", "margin", "offeredPrice", "deliveryTimeWeeks", "request", "requestId", "materials", "customerOfferItem", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: unwrapReadonly(Object.freeze({ "name": "string", "quantities": "number[]", "processingMethod": "Orders.ProcessingMethod", "processingMethod$id": "string", "relatedAttachmentIds": "number[]", "dimensions": "string", "margin": "number", "offeredPrice": "number", "deliveryTimeWeeks": "number", "request": "Orders.CustomerRequest", "requestId": "Orders.CustomerRequest.Id", "materials": "Orders.CustomerRequestItemMaterial[]", "customerOfferItem": "Orders.CustomerOfferItem", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: unwrapReadonly(Object.freeze(["processingMethod"] as const)),
        searchInProperties: unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: unwrapReadonly(Object.freeze({ request: () => Orders.CustomerRequest } as const)),
        oneToManyRelationships: unwrapReadonly(Object.freeze({ materials: () => Orders.CustomerRequestItemMaterial } as const)),
        oneToOneOwningRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: unwrapReadonly(Object.freeze({ customerOfferItem: () => Orders.CustomerOfferItem } as const)),
        embeddedEntities: unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θname = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θquantities = Signals.proxySignalDeferred<number[]>(() => (undefined) as any);
    private readonly θprocessingMethod = Signals.proxySignalDeferred<This.ProcessingMethod>(() => (new This.ProcessingMethod(This.ProcessingMethod.Unknown)) as any);
    private readonly θrelatedAttachmentIds = Signals.proxySignalDeferred<number[]>(() => (undefined) as any);
    private readonly θdimensions = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θmargin = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θofferedPrice = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θdeliveryTimeWeeks = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θrequest = Signals.proxySignalDeferred<Orders.CustomerRequest>(() => (undefined) as any);
    private readonly θrequestId = Signals.proxySignalDeferred<Orders.CustomerRequest.Id>(() => (undefined) as any);
    private readonly θmaterials = Signals.proxySignalDeferred<Orders.CustomerRequestItemMaterial[]>(() => (undefined) as any);
    private readonly θcustomerOfferItem = Signals.proxySignalDeferred<Orders.CustomerOfferItem>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Orders.CustomerRequestItem' {
        return 'Orders.CustomerRequestItem'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Orders.CustomerRequestItem' {
        return 'Orders.CustomerRequestItem'
    }

    static get __baseType(): 'Orders.CustomerRequestItem' {
        return 'Orders.CustomerRequestItem'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Orders.CustomerRequestItem' {
        return 'Orders.CustomerRequestItem'
    }

    get [BoInfoSymbol]() {
        return Orders__CustomerRequestItem[BoInfoSymbol]
    }

    get name(): string {
        return this.θname?.()
    }

    set name(name) {
        this.θname.set(coerceDataType(name, 'string', false, true))
    }

    get quantities(): number[] {
        return this.θquantities?.()
    }

    set quantities(quantities) {
        this.θquantities.set(coerceDataType(quantities, 'number[]', false, true))
    }

    get processingMethod(): This.ProcessingMethod {
        return this.θprocessingMethod?.()
    }

    set processingMethod(processingMethod: This.ProcessingMethod | This.ProcessingMethod.Id) {
        this.θprocessingMethod().θupdate(processingMethod)
    }

    @jsonProperty(String)
    get 'processingMethod$id'(): This.ProcessingMethod.Id {
        return this.θprocessingMethod?.()?.id
    }

    set 'processingMethod$id'(processingMethod: string) {
        this.θprocessingMethod().θupdate(processingMethod as This.ProcessingMethod.Id)
    }

    get relatedAttachmentIds(): number[] {
        return this.θrelatedAttachmentIds?.()
    }

    set relatedAttachmentIds(relatedAttachmentIds) {
        this.θrelatedAttachmentIds.set(coerceDataType(relatedAttachmentIds, 'number[]', false, true))
    }

    get dimensions(): string {
        return this.θdimensions?.()
    }

    set dimensions(dimensions) {
        this.θdimensions.set(coerceDataType(dimensions, 'string', false, true))
    }

    get margin(): number {
        return this.θmargin?.()
    }

    set margin(margin) {
        this.θmargin.set(coerceDataType(margin, 'number', false, true))
    }

    get offeredPrice(): number {
        return this.θofferedPrice?.()
    }

    set offeredPrice(offeredPrice) {
        this.θofferedPrice.set(coerceDataType(offeredPrice, 'number', false, true))
    }

    get deliveryTimeWeeks(): number {
        return this.θdeliveryTimeWeeks?.()
    }

    set deliveryTimeWeeks(deliveryTimeWeeks) {
        this.θdeliveryTimeWeeks.set(coerceDataType(deliveryTimeWeeks, 'number', false, true))
    }

    get request(): Orders.CustomerRequest {
        return this.θrequest?.()
    }

    set request(request) {
        this.θrequest.set(coerceDataType(request, Orders.CustomerRequest, false, true))
        if (request) {
            this.θrequestId.set(request.id)
        } else if (request === null && request) {
            this.θrequestId.set(null)
        }
    }

    get requestId(): Orders.CustomerRequest.Id {
        return this.θrequestId?.()
    }

    set requestId(requestId) {
        if (requestId === null) this.θrequest.set(null)
        if (this.request?.id && requestId != this.request.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θrequestId.set(coerceDataType(requestId, 'Orders.CustomerRequest.Id', false, true))
    }

    get materials(): Orders.CustomerRequestItemMaterial[] {
        return this.θmaterials?.()
    }

    set materials(materials) {
        this.θmaterials.set(coerceDataType(materials, Orders.CustomerRequestItemMaterial, true, true))
        this.materials?.forEach?.(item => { if (item && "item" in item) item.item = this as any })
    }

    get customerOfferItem(): Orders.CustomerOfferItem {
        return this.θcustomerOfferItem?.()
    }

    set customerOfferItem(customerOfferItem) {
        this.θcustomerOfferItem.set(coerceDataType(customerOfferItem, Orders.CustomerOfferItem, false, true))
        if (customerOfferItem) customerOfferItem.requestItem = this as any
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Orders__CustomerRequestItem>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                materials: [],
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Orders__CustomerRequestItem()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Orders__CustomerRequestItem>, restrictToClass?: Class<Partial<Orders__CustomerRequestItem>>) {
        assignCommonProperties(this, source, { restrictToClass })
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('name', 'quantities', 'processingMethod$id', 'relatedAttachmentIds', 'dimensions', 'margin', 'offeredPrice', 'deliveryTimeWeeks', 'request', 'requestId', 'materials', 'customerOfferItem', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Orders__CustomerRequestItem {
        return equal(this, other)
    }
}

namespace Orders__CustomerRequestItem { }

export import CustomerRequestItem = Orders__CustomerRequestItem
setTimeout(() => {
    jsonProperty(() => String)(Orders__CustomerRequestItem.prototype, 'name')
    jsonArrayProperty(() => Number)(Orders__CustomerRequestItem.prototype, 'quantities')
    jsonArrayProperty(() => Number)(Orders__CustomerRequestItem.prototype, 'relatedAttachmentIds')
    jsonProperty(() => String)(Orders__CustomerRequestItem.prototype, 'dimensions')
    jsonProperty(() => Number)(Orders__CustomerRequestItem.prototype, 'margin')
    jsonProperty(() => Number)(Orders__CustomerRequestItem.prototype, 'offeredPrice')
    jsonProperty(() => Number)(Orders__CustomerRequestItem.prototype, 'deliveryTimeWeeks')
    jsonProperty(() => Orders.CustomerRequest)(Orders__CustomerRequestItem.prototype, 'request')
    jsonProperty(() => Orders.CustomerRequest.Id)(Orders__CustomerRequestItem.prototype, 'requestId')
    jsonArrayProperty(() => Orders.CustomerRequestItemMaterial)(Orders__CustomerRequestItem.prototype, 'materials')
    jsonProperty(() => Orders.CustomerOfferItem)(Orders__CustomerRequestItem.prototype, 'customerOfferItem')
    jsonProperty(() => Date)(Orders__CustomerRequestItem.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerRequestItem.prototype, 'createdBy')
    jsonProperty(() => Date)(Orders__CustomerRequestItem.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerRequestItem.prototype, 'updatedBy')
    jsonProperty(() => Date)(Orders__CustomerRequestItem.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerRequestItem.prototype, 'deletedBy')
    jsonProperty(() => Number)(Orders__CustomerRequestItem.prototype, 'versionNumber')
})

export const CustomerRequestItemθId = Number;

export type CustomerRequestItemθId = number;

namespace Orders__CustomerRequestItem {
    export type Id = NominalType<number, 'Orders.CustomerRequestItem'>

}
